import { useState } from 'react'
import { ConfirmationModal } from 'components/organisms/modals/confirmation-modal'
import { Button } from 'components/atoms/button'

export interface LogoutConfirmationModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	onConfirm: () => void
}

export function LogoutConfirmationModal({ open, setOpen, onConfirm }: LogoutConfirmationModalProps) {
	const handleConfirm = () => {
		onConfirm()
		setOpen(false)
	}

	const handleCancel = () => {
		setOpen(false)
	}

	return (
		<ConfirmationModal title="Log Out" open={open} setOpen={setOpen}>
			<div>
				<div className="mb-8">Are you sure you want to log out?</div>
				<div className="space-y-2">
					<Button variant="secondary" fullWidth onClick={handleConfirm}>
						Yes
					</Button>
					<Button variant="secondary" fullWidth onClick={handleCancel}>
						Cancel
					</Button>
				</div>
			</div>
		</ConfirmationModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface LogoutConfirmationModalManagedProps {
	onConfirm: () => void
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'logout-confirmation': LogoutConfirmationModalManagedProps
	}
}

export function ManagedLogoutConfirmationModal({
	onClose,
	onConfirm,
}: LogoutConfirmationModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<LogoutConfirmationModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			onConfirm={() => { onConfirm(); handleClose() }}
		/>
	)
}
